import { FunctionComponent, useState } from 'react'
import { Box, TextField, Typography, Link, InputAdornment, IconButton } from '@material-ui/core'
//@ts-ignore
import styled, { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { UserRoles } from 'common/types'
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Button } from 'common/atoms/Button/Button'

interface SignInEmailProps {
  onSubmit: Function
  username: string
  password: string
  setUsername: Function
  setPassword: Function
  setSelectedPage: Function
  confirmEmail?: Function
  mode?: UserRoles
}

const StyledTextField = styled(TextField)`
  input:disabled {
    color: ${props => props.theme.colors.accent} !important;
    cursor: default;
  }
`

export const SignInEmail: FunctionComponent<SignInEmailProps> = ({
  username,
  password,
  setUsername,
  setPassword,
  onSubmit,
  setSelectedPage,
  mode,
}) => {
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const [showPassword, setShowPassword] = useState(false)

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width={isDevice ? '97%' : '100%'}
      padding={isDevice ? '0 2em' : '0 10em'}
      margin="0.5em 1em"
    >
      <Box width={isDevice ? '100%' : '30em'}>
        <Box m="0 0 1em 0">
          <StyledTextField
            placeholder={mode === UserRoles.Partner ? 'Company Email' : 'Email'}
            onChange={e => setUsername(e.target.value)}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                onSubmit()
              }
            }}
            variant="outlined"
            fullWidth
            value={username}
            size="small"
          />
        </Box>

        <Box m="0.5em 0">
          <StyledTextField
            variant="outlined"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            fullWidth
            onChange={e => setPassword(e.target.value)}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                onSubmit()
              }
            }}
            value={password}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(prevState => !prevState)}
                  >
                    {showPassword ? <Visibility style={{ color: theme.colors.accent}} /> : <VisibilityOff style={{ color: theme.colors.accent}} />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>
        <Box m="1em 0" display="flex" justifyContent="flex-end">
          <Typography variant="body2" align="right">
            <Link
              onClick={() => {
                setSelectedPage(1)
              }}
            >
              <Box color={theme.colors.primary}>Forgot Password?</Box>
            </Link>
          </Typography>
        </Box>
        <Box m="1em 0">
          <Button
            design='primary'
            onClick={() => onSubmit()}
            fullWidth
            disabled={!username.trim() || !password.trim()}
          >
            <strong>SIGN IN</strong>
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
